export default {
  title: 'Вход'
}
